/* Homepage-only image carousels, including cards inserted by existing feeds. */
(() => {
  const root = document.querySelector('.homepage-hardware #main-content');
  if (!root) return;
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const canHover = window.matchMedia('(hover: hover) and (pointer: fine)');
  const mobileCards = window.matchMedia('(max-width: 767px)');
  const states = new Set();

  function bind(carousel) {
    if (carousel.dataset.homeCarouselBound) return;
    const images = [...carousel.querySelectorAll('.pc__img')];
    const media = carousel.closest('.pc__media');
    if (!media || images.length < 2) return;
    carousel.dataset.homeCarouselBound = 'true';
    let index = 0;
    let timer;
    let hovered = false;
    let dots = media.querySelector('[data-dots]');
    if (!dots) {
      dots = document.createElement('div');
      dots.className = 'pc__dots';
      dots.dataset.dots = '';
      media.append(dots);
    }
    const buttons = images.map((image, position) => {
      const button = document.createElement('button');
      button.type = 'button';
      button.setAttribute('aria-label', `Show product image ${position + 1} of ${images.length}`);
      button.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopPropagation();
        stop();
        show(position);
      });
      return button;
    });
    dots.replaceChildren(...buttons);

    function show(next) {
      index = (next + images.length) % images.length;
      images.forEach((image, position) => image.classList.toggle('is-active', position === index));
      buttons.forEach((button, position) => button.setAttribute('aria-pressed', String(position === index)));
    }
    function stop() { clearInterval(timer); timer = undefined; }
    function play() {
      stop();
      if (mobileCards.matches) { show(0); return; }
      if (!hovered || !canHover.matches || reduceMotion.matches || document.hidden || media.contains(document.activeElement)) return;
      timer = setInterval(() => show(index + 1), 1200);
    }
    media.addEventListener('mouseenter', () => { hovered = true; play(); });
    media.addEventListener('mouseleave', () => { hovered = false; stop(); });
    media.addEventListener('focusin', stop);
    media.addEventListener('focusout', () => queueMicrotask(play));
    show(0);
    states.add({ media, stop, play });
  }
  function scan(scope) {
    if (!(scope instanceof Element)) return;
    if (scope.matches('[data-carousel]')) bind(scope);
    scope.querySelectorAll('[data-carousel]').forEach(bind);
  }
  scan(root);
  new MutationObserver((records) => {
    records.forEach((record) => record.addedNodes.forEach(scan));
    for (const state of states) {
      if (!state.media.isConnected) { state.stop(); states.delete(state); }
    }
  }).observe(root, { childList: true, subtree: true });
  const refresh = () => states.forEach((state) => state.play());
  reduceMotion.addEventListener('change', refresh);
  canHover.addEventListener('change', refresh);
  mobileCards.addEventListener('change', refresh);
  document.addEventListener('visibilitychange', refresh);
  window.addEventListener('pagehide', () => states.forEach((state) => state.stop()));
})();
